import { render, staticRenderFns } from "./SubspecialtiesComponent.vue?vue&type=template&id=6fd0c0bb&scoped=true"
import script from "./SubspecialtiesComponent.vue?vue&type=script&lang=js"
export * from "./SubspecialtiesComponent.vue?vue&type=script&lang=js"
import style0 from "./SubspecialtiesComponent.vue?vue&type=style&index=0&id=6fd0c0bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd0c0bb",
  null
  
)

export default component.exports